module.exports = __webpack_public_path__ + "fonts/bitfont.d0ace47f.woff";